import type { QueryClient, QueryKey } from "@tanstack/react-query";

/**
 * writes each row under its own detail key, which every by-id lookup reads
 * first. `updatedAt` is when the response arrived: rows from a response older
 * than the cached copy are skipped, and none are dated newer than they are
 */
export function cacheDetails<T extends { id: string }>(
  queryClient: QueryClient,
  keyFor: (id: string) => QueryKey,
  rows: T[],
  updatedAt = Date.now(),
) {
  for (const row of rows) {
    const key = keyFor(row.id);
    if ((queryClient.getQueryState(key)?.dataUpdatedAt ?? 0) > updatedAt) {
      continue;
    }
    queryClient.setQueryData(key, row, { updatedAt });
  }
}
